import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBubble1Background = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 1025 1024",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M773.917 731.408C631.196 703.85 497.017 719.638 374.301 800.035L374.306 800.049C334.787 685.155 254.048 609.514 142.234 563.911C142.471 563.672 142.677 563.444 142.867 563.233C143.262 562.795 143.591 562.43 143.994 562.195C169.927 547.312 192.417 529.111 211.521 507.727L86.5 382.706H274.257C277.155 364.951 277.503 346.72 274.733 327.979C273.417 319.122 270.969 310.436 268.512 301.721C267.383 297.715 266.252 293.704 265.229 289.668C269.212 290.459 273.222 291.294 277.255 292.133C286.053 293.965 294.96 295.819 303.93 297.293C377.087 309.271 449.981 306.785 522.458 292.066C560.532 284.344 597.677 273.202 632.363 255.373C645.021 248.862 657.263 241.56 669.313 234.372C674.755 231.126 680.156 227.904 685.539 224.789C725.786 349.279 811.241 426.556 939.135 459.539C885.008 483.184 842.898 520.384 811.609 569.432C779.966 619.021 764.009 672.738 773.917 731.408Z",
		fill: "currentColor",
		strokeWidth: 16,
		stroke: "var(--color-mid-blue)"
	})
});
const ForwardRef = forwardRef(SvgBubble1Background);
export default ForwardRef;
